<template>
  <div>
    <div
      style="display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0px; z-index: 10; background-color: #e4ede6;"
      class="py-0"
    >
      <div
        class="ml-2"
        style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;"
      >
        <router-link
          title="Go Back to All Support Requests"
          :to="{ name: technicianMode ? 'HelpDeskTechnicianRequests' : 'HelpDeskRequests' }"
          style="text-decoration: none; color: #2e7d32; font-weight: 600; font-size: 14px;"
          >All Support Requests</router-link
        >
        <span style="color: #9e9e9e;">/</span>
        <span
          v-html="request.subject"
          style="font-size: 20px; font-weight: 700; color: #212121;"
        ></span>
        <a
          title="Open in ManageEngine"
          v-if="isTechnician() && technicianMode"
          :href="
            `https://utaw.sdpondemand.manageengine.com/app/itdesk/ui/requests/${
              request.manageengineID
            }/details`
          "
          target="_blank"
          style="text-decoration: none;"
        >
          <span
            style="
                background-color: #e8f5e9;
                color: #2e7d32;
                border: 1px solid #a5d6a7;
                border-radius: 6px;
                padding: 2px 8px;
                font-size: 13px;
                font-weight: 600;
                white-space: nowrap;
                display: inline-flex;
                align-items: center;
                gap: 3px;
              "
            >{{ "#" + request.displayID
            }}<v-icon small color="green" style="font-size: 13px;"
              >mdi-open-in-new</v-icon
            ></span
          >
        </a>
      </div>

      <div
        class=" pb-1 pt-2"
        style="display: flex; align-items: center; flex-wrap: wrap; gap: 8px;"
      >
        <v-btn
          small
          flat
          class="ticket-header-nav"
          :disabled="!hasPrevTicket"
          @click="goToPrevTicket"
          title="Previous"
        >
          &lt;
        </v-btn>
        <v-btn
          small
          flat
          class="ticket-header-nav"
          :disabled="!hasNextTicket"
          @click="goToNextTicket"
          title="Next"
        >
          &gt;
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { isTechnician } from "./helpDeskHelpers";
export default {
  props: {
    initialData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      request: this.initialData.ticket,
      technicianMode: this.initialData.technicianMode,
    };
  },

  watch: {
    initialData(newVal) {
      this.request = newVal.ticket;
      this.technicianMode = newVal.technicianMode;
    },
  },

  computed: {
    ticketIds() {
      const query = this.$route.query || {};
      const numericKeys = Object.keys(query)
        .filter((k) => !isNaN(k))
        .sort((a, b) => Number(a) - Number(b));
      return numericKeys.map((k) => query[k]);
    },
    currentTicketIndex() {
      if (!this.$route.params || !this.$route.params.id) return -1;
      return this.ticketIds.indexOf(this.$route.params.id);
    },
    hasPrevTicket() {
      return this.currentTicketIndex > 0;
    },
    hasNextTicket() {
      return (
        this.currentTicketIndex > -1 &&
        this.currentTicketIndex < this.ticketIds.length - 1
      );
    },
  },

  methods: {
    isTechnician() {
      return isTechnician();
    },
    goToPrevTicket() {
      this.goToOffset(-1);
    },

    goToNextTicket() {
      this.goToOffset(1);
    },

    goToOffset(offset) {
      const ids = this.ticketIds;
      if (!ids || ids.length === 0) return;
      const currentIndex = this.currentTicketIndex;
      if (currentIndex === -1) return;
      const nextIndex = currentIndex + offset;
      if (nextIndex < 0 || nextIndex >= ids.length) return;
      const nextId = ids[nextIndex];
      this.$router.push({
        name: this.$route.name,
        params: { ...this.$route.params, id: nextId },
        query: this.$route.query,
      });
    },
  },
};
</script>
